// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
// Подсветка ячеек, влияющих на выбранную (AttrGrid.influence_update, опция doc.params.influence_highlight): слагаемое формулы — лист дерева
// данных; его метка ложится на саму строку или на ближайшего ВИДИМОГО предка (свёрнутые детали). Замер dev02 (Мальтофер ФОЛ, курсор
// «Запас на початок → МС → Грузія ⇒ Узбекистан 1030692» × Квітень 2027): у РАСКРЫТОГО «ЗП. Надходження на МС» лист «ТС Aversi хранение»
// партии 1030327 спрятан фильтром пустых строк (значения нет) — метка поднималась на родителя (30-42 «+ 85 500» рядом с точной 33-42
// «+ 76 000»); так же «Ex-Distr» (80-42 «− 24 800»): его единственный зависимый лист — пустая спрятанная строка «Грузія ↓ Витрата»,
// видимые дети (Узбекистан / Україна) от склада не зависят. Правило (выключатель fe.ux.cellBasisDeepest, по умолчанию вкл):
//   • строка-родитель раскрыта, а лист спрятан не свёрткой, а фильтром: пустое значение листа в этой колонке — метки нет совсем
//     (слагаемое ноль, на экране ему нечего показать);
//   • непустой спрятанный лист — метка родителю «запасная»: снимается, если в той же колонке помечен видимый потомок этого родителя
//     (точная ячейка уже на экране); иначе остаётся;
//   • свёрнутый родитель и видимая строка листа — как раньше.

// куда класть метку листа x: 'direct' — сама строка или видимый предок по свёртке (как раньше), 'skip' — не метить,
// 'fallback' — раскрытый видимый предок v (лист спрятан фильтром), метка запасная
export function inflDeepest_target({ x, v, vExpanded, empty }) {
    if (!v || v === x || !vExpanded) return 'direct'
    return empty ? 'skip' : 'fallback'
}

// пустое значение ячейки: нет числа или ноль
export function inflDeepest_isEmpty(raw) {
    if (raw === null || raw === undefined || raw === '') return true
    const n = typeof raw === 'number' ? raw : parseFloat(raw)
    return Number.isNaN(n) || n === 0
}

// снять запасные метки родителей, у которых в той же колонке помечен видимый потомок.
// cells: Map(строка → Map(binding → kind)); fallback: Map(строка → Set(binding)) — метки, поставленные только как запасные;
// parentOf: Map(строка → родитель) или функция. Возвращает число снятых меток; cells правится на месте
export function inflDeepest_prune(cells, fallback, parentOf) {
    if (!cells || !fallback || !fallback.size) return 0
    const up = typeof parentOf === 'function' ? parentOf : (y) => parentOf?.get?.(y)
    const covered = new Map()   // предок → Set(binding), помеченных у его потомков
    for (const [row, cm] of cells) {
        const fb = fallback.get(row)
        const own = [...cm.keys()].filter(b => !(fb && fb.has(b)))   // запасная метка потомка точной не считается
        if (!own.length) continue
        for (let p = up(row), n = 0; p && n < 64; p = up(p), n++) {
            if (!fallback.has(p)) continue
            let s = covered.get(p); if (!s) covered.set(p, (s = new Set()))
            for (const b of own) s.add(b)
        }
    }
    let removed = 0
    for (const [row, bset] of fallback) {
        const cov = covered.get(row), cm = cells.get(row)
        if (!cov || !cm) continue
        for (const b of bset) if (cov.has(b) && cm.has(b)) { cm.delete(b); removed++ }
        if (!cm.size) cells.delete(row)
    }
    return removed
}
